// extracted by mini-css-extract-plugin
export default {"adminFeeInfoBlock":"Miy0nEDZ95HVNbvP4pvZ"};